export default "__VITE_PUBLIC_ASSET__25e97142__"